/**
 * Holster "Passt dazu / Topseller" Picker (Cart Drawer, Preview).
 * Pool + Regeln: assets/holster-cart-picks.json (Ranking: Verkäufe 90 Tage).
 * Einzelprodukte gemischt (max. 2 je Kategorie), passend zum Warenkorb priorisiert,
 * nur verfügbare Varianten, nichts was schon im Warenkorb liegt.
 * Ausgewählte werden in EINEM /cart/add.js (items[]) Call hinzugefügt.
 */
(function (window, document) {
  'use strict';
  if (window.__holsterCartPicks) return;
  window.__holsterCartPicks = true;

  var SECTION = 'cart-drawer-section';
  var cfgPromise = null, productCache = {}, renderSeq = 0, selected = {};

  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function money(c) { return (c / 100).toFixed(2).replace('.', ',') + '\u00a0€'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function slots() { return document.querySelectorAll('[data-holster-cart-picks]'); }
  function getJSON(u) { return fetch(u, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }
  function loadCfg(slot) {
    if (!cfgPromise) {
      var u = slot && slot.getAttribute('data-config-url');
      cfgPromise = u ? getJSON(u).catch(function () { cfgPromise = null; return null; }) : Promise.resolve(null);
    }
    return cfgPromise;
  }
  function loadProduct(h) {
    if (!productCache[h]) productCache[h] = getJSON(root() + 'products/' + encodeURIComponent(h) + '.js').catch(function () { return null; });
    return productCache[h];
  }
  // gleiche Logik wie build_pool.py
  function category(type, handle) {
    var t = (type || '').toLowerCase(), h = (handle || '').toLowerCase();
    if (t === 'tobacco' || t === 'tabak') return 'tabak';
    if (t === 'kohle' || h.indexOf('naturkohle') > -1 || h.indexOf('blackcoco') > -1) return 'kohle';
    if (t === 'e-liquid' || t === 'e-liquids') return 'liquid';
    if (h.indexOf('velora') > -1 || h.indexOf('pod-kit') > -1) return 'pod';
    if (h.indexOf('pixl') > -1 || h.indexOf('einweg') > -1 || t === 'vape') return 'einweg';
    return null;
  }
  function firstAvail(p) {
    if (!p || !p.available) return null;
    return (p.variants || []).filter(function (v) { return v.available && v.price <= 4000; })[0] || null;
  }

  // Reihenfolge der Kategorie-Slots: erst Affinität zum Warenkorb, dann Round-Robin-Fill
  function plan(cfg, cartCats) {
    var seq = [];
    cartCats.forEach(function (c) { ((cfg.affinity || {})[c] || []).forEach(function (a) { seq.push(a); }); });
    var order = cfg.fill_order || Object.keys(cfg.pool || {});
    for (var r = 0; r < (cfg.max_per_category || 2); r++) order.forEach(function (c) { seq.push(c); });
    return seq;
  }

  function choose(cfg, cart) {
    var max = cfg.max_items || 8, perCat = cfg.max_per_category || 2;
    var inCart = {}, cartCats = [];
    (cart.items || []).forEach(function (i) {
      inCart[i.handle] = true;
      var c = category(i.product_type, i.handle);
      if (c && cartCats.indexOf(c) === -1) cartCats.push(c);
    });
    var seq = plan(cfg, cartCats), idx = {}, count = {}, used = {}, picks = [];
    var affN = 0; cartCats.forEach(function (c) { affN += ((cfg.affinity || {})[c] || []).length; });
    var i = 0;
    function step() {
      if (picks.length >= max || i >= seq.length) return Promise.resolve(picks);
      var c = seq[i], isAff = i < affN; i++;
      if ((count[c] || 0) >= perCat) return step();
      var list = (cfg.pool || {})[c] || [];
      function tryNext() {
        var k = idx[c] || 0;
        if (k >= list.length) return step();
        idx[c] = k + 1;
        var h = list[k];
        if (inCart[h] || used[h]) return tryNext();
        return loadProduct(h).then(function (p) {
          var v = firstAvail(p);
          if (!v || inCart[p.handle]) return tryNext();
          used[h] = true; count[c] = (count[c] || 0) + 1;
          picks.push({ p: p, v: v, cat: c, match: isAff });
          return step();
        });
      }
      return tryNext();
    }
    return step();
  }

  function img(p, v) {
    var s = (v.featured_image && v.featured_image.src) || p.featured_image || (p.images && p.images[0]) || '';
    if (!s) return '';
    if (s.indexOf('//') === 0) s = 'https:' + s;
    return s + (s.indexOf('?') === -1 ? '?' : '&') + 'width=240';
  }

  function cardHTML(it, labels) {
    var id = it.v.id, on = !!selected[id];
    var vt = it.v.title && it.v.title !== 'Default Title' ? '<span class="hcp__vt">' + esc(it.v.title) + '</span>' : '';
    var u = img(it.p, it.v);
    return '<li class="hcp__item">' +
      '<button type="button" class="hcp__card' + (on ? ' is-on' : '') + '" role="checkbox" aria-checked="' + on + '" data-hcp-toggle="' + id + '" data-price="' + it.v.price + '">' +
      '<span class="hcp__check" aria-hidden="true"></span>' +
      '<span class="hcp__tag">' + esc(it.match ? 'Passt dazu' : (labels[it.cat] || 'Topseller')) + '</span>' +
      '<span class="hcp__img">' + (u ? '<img src="' + esc(u) + '" alt="" loading="lazy" width="120" height="120">' : '') + '</span>' +
      '<span class="hcp__name">' + esc(it.p.title) + '</span>' + vt +
      '<span class="hcp__price">' + money(it.v.price) + '</span>' +
      '</button></li>';
  }

  function updateBtn(scope) {
    (scope ? [scope] : slots()).forEach(function (s) {
      var n = 0, sum = 0;
      s.querySelectorAll('[data-hcp-toggle]').forEach(function (b) {
        var on = !!selected[b.getAttribute('data-hcp-toggle')];
        b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on);
        if (on) { n++; sum += Number(b.getAttribute('data-price')); }
      });
      var btn = s.querySelector('[data-hcp-add]');
      if (btn && !btn.classList.contains('is-busy')) {
        btn.disabled = !n;
        btn.textContent = n ? 'Ausgewählte in den Warenkorb (' + n + ') – ' + money(sum) : 'Produkte antippen zum Auswählen';
      }
    });
  }

  function render() {
    var list = slots();
    if (!list.length) return;
    var seq = ++renderSeq;
    Promise.all([loadCfg(list[0]), getJSON(root() + 'cart.js')]).then(function (res) {
      var cfg = res[0], cart = res[1];
      if (!cfg || seq !== renderSeq) return;
      return choose(cfg, cart).then(function (picks) {
        if (seq !== renderSeq) return;
        var ids = {}; picks.forEach(function (x) { ids[x.v.id] = 1; });
        Object.keys(selected).forEach(function (k) { if (!ids[k]) delete selected[k]; });
        var html = picks.length < 2 ? '' :
          '<div class="hcp__head"><p class="hcp__heading">Passt dazu &amp; Topseller</p><span class="hcp__hint">Antippen zum Auswählen</span></div>' +
          '<ul class="hcp__list">' + picks.map(function (x) { return cardHTML(x, cfg.labels || {}); }).join('') + '</ul>' +
          '<button type="button" class="hcp__add" data-hcp-add disabled></button>' +
          '<p class="hcp__msg" role="status" aria-live="polite"></p>';
        slots().forEach(function (s) {
          if (s.getAttribute('data-sig') !== html) { s.innerHTML = html; s.setAttribute('data-sig', html); }
          s.hidden = !html;
          updateBtn(s);
        });
      });
    }).catch(function () {});
  }

  function refreshDrawer(cart) {
    return fetch(root() + '?sections=' + SECTION, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (data) {
      var html = data && data[SECTION];
      if (!html) return;
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.cart-drawer__inner');
      var inner = document.querySelector('#cart-drawer .cart-drawer__inner');
      if (fresh && inner) { inner.className = fresh.className; inner.innerHTML = fresh.innerHTML; }
      document.querySelectorAll('cart-icon').forEach(function (icon) { try { if (icon.renderCartBubble) icon.renderCartBubble(cart.item_count, false); } catch (e) {} });
      document.dispatchEvent(new CustomEvent('holster:cart:rerendered', { detail: { cart: cart, sourceId: 'holster-cart-picks' } }));
      render();
    });
  }

  function onClick(e) {
    var t = e.target.closest && e.target.closest('[data-hcp-toggle]');
    if (t) {
      e.preventDefault();
      var id = t.getAttribute('data-hcp-toggle');
      if (selected[id]) delete selected[id]; else selected[id] = true;
      updateBtn();
      return;
    }
    var btn = e.target.closest && e.target.closest('[data-hcp-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var slot = btn.closest('[data-holster-cart-picks]');
    var msg = slot && slot.querySelector('.hcp__msg');
    var ids = [];
    slot.querySelectorAll('[data-hcp-toggle]').forEach(function (b) { var id = b.getAttribute('data-hcp-toggle'); if (selected[id]) ids.push(Number(id)); });
    if (!ids.length) return;
    btn.disabled = true; btn.classList.add('is-busy'); btn.textContent = 'Wird hinzugefügt…';
    fetch(root() + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { selected = {}; return getJSON(root() + 'cart.js'); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'holster-cart-picks', data: { source: 'holster-cart-picks', itemCount: cart.item_count } } }));
        return refreshDrawer(cart);
      })
      .catch(function (err) {
        btn.classList.remove('is-busy'); updateBtn();
        if (msg) msg.textContent = (err && (err.description || err.message)) || 'Artikel konnten nicht hinzugefügt werden.';
      });
  }

  function boot() {
    document.addEventListener('click', onClick);
    render();
    ['cart:update', 'cart:change', 'holster:cart:rerendered', 'cart-drawer:refreshed', 'theme:cart:change'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        if (e && e.detail && e.detail.sourceId === 'holster-cart-picks') return;
        window.setTimeout(render, 300);
      });
    });
    var drawer = document.getElementById('cart-drawer');
    if (drawer && window.MutationObserver) {
      var t = null;
      new MutationObserver(function () {
        if (t) return;
        t = window.setTimeout(function () {
          t = null;
          var need = false;
          slots().forEach(function (s) { if (!s.hasAttribute('data-sig')) need = true; });
          if (need) render();
        }, 200);
      }).observe(drawer, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.HolsterCartPicks = { render: render, _choose: choose, _category: category };
})(window, document);
